import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Button, Breadcrumbs, Input, Subtitle } from '../../../../components/UI/ComponentsUI';
import { translate, showMessageToastCustom, isNullOrEmpty, getUrlRepositoryApi, leftPad } from '../../../../utils/util';
import { validateInputsRequired, onValueChange } from '../../../../utils/handleChangeHooks';
import LinePickingService from '../../../../services/LinePickingService';
import ModalUploadMapping from './ModalUploadMapping';
import { ENUMS } from '../../../../utils/constants';
import StockService from '../../../../services/StockService';
import RoutePickingService from '../../../../services/RoutePickingService';
import SelectMapping from '../../../../components/UI/SelectMapping';
import SelectMappingModelUse from '../../../../components/UI/SelectMappingModelUse';
import SelectItem from '../../../../components/UI/SelectItem';

const MappingInsert = (props) => {
    const update = props.location?.state?.update;
    const [mapping, setMapping] = useState(update && props.mapping ? props.mapping : {});
    const [openModal, setOpenModal] = useState(false);
    const [arrayDrop, setArrayDrop] = useState([]);

    useEffect(() => {
        if (!update) {
            props.getLastMapping((lastMapping) => {
                if (lastMapping && lastMapping.id) {
                    const aux = {};
                    Object.assign(aux, mapping);
                    aux.code = `L${leftPad(lastMapping.id + 1, 9, '0')}`;
                    setMapping(aux);
                }
            })
        }
        props.getRoutes({ routeType: ENUMS.eRouteType.LinePicking.value }, (data) => {
            var drop = data.map((i) => {
                return { id: i.value, text: i.value };
            }).sort((a, b) => {
                if (a.text < b.text) { return -1; }
                if (a.text > b.text) { return 1; }
                return 0;
            });
            setArrayDrop(drop);
        });

        if (props.mapping && props.mapping.id) {
            const aux = {};
            Object.assign(aux, props.mapping);
            aux.code = `L${leftPad(props.mapping.id + 1, 9, '0')}`;
            aux.mappingPartNumberUseModelIds = props.mapping?.mappingPartNumberUseModel?.map(f => f.partNumberUseModelId.toString());
            setMapping(aux);
        }
        // eslint-disable-next-line
    }, []);

    const onChange = (event) => {
        onValueChange(event, mapping, setMapping);
        if (!isNullOrEmpty(mapping.route)
            && !isNullOrEmpty(mapping.street) && !isNullOrEmpty(mapping.station) && !isNullOrEmpty(mapping.line)
            && !isNullOrEmpty(mapping.gravitational) && !isNullOrEmpty(mapping.space) && !isNullOrEmpty(mapping.side)) {
            mapping.pdu = `${mapping.route}.${mapping.street}.${mapping.station}.${mapping.line}.${mapping.gravitational}.${mapping.space}.${mapping.side}`;
            setMapping({ ...mapping });
        }
    };

    const getNameFile = (mdr) => {
        if (mdr) {
            return !isNullOrEmpty(mapping?.fileNameMdr) && mapping.fileNameMdr.includes("Mdr-") ? `${getUrlRepositoryApi(window)}/api/repository/file/download?FileName=expedition/mapping/${mapping.fileNameMdr}` : mapping?.fileNameMdr
        } else {
            return !isNullOrEmpty(mapping?.fileNamePartNumber) && mapping.fileNamePartNumber.includes("PartNumber-") ? `${getUrlRepositoryApi(window)}/api/repository/file/download?FileName=expedition/mapping/${mapping.fileNamePartNumber}` : mapping?.fileNamePartNumber
        }
    }

    const addImage = (image, mdr) => {
        if (!isNullOrEmpty(image)) {
            if (mdr) {
                mapping.fileNameMdr = URL.createObjectURL(image);
                mapping.fileMdrNew = image;
                document.getElementById("fileMdr").value = "";

            } else {
                mapping.fileNamePartNumber = URL.createObjectURL(image);
                mapping.filePartNumberNew = image;

                document.getElementById("filePartNumber").value = "";
            }

            setMapping({ ...mapping });
        }
    };

    const onConfirm = () => {
        if (validateInputsRequired("formMappingInsert")) {
            if (update) {
                props.updateMapping(mapping, (response) => {
                    if (!response) {
                        showMessageToastCustom(translate('warning', 'general'), translate('failed-to-update', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
                    } else {
                        showMessageToastCustom(translate('general.info'), translate('sucess-to-update', 'general'), 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                        props.history.go(-1);
                    }
                });
            } else {
                props.createMapping(mapping, (response) => {
                    if (!response) {
                        showMessageToastCustom(translate('warning', 'general'), translate('failed-to-include', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
                    } else {
                        showMessageToastCustom(translate('general.info'), translate('sucess-to-include', 'general'), 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                        props.history.go(-1);
                    }
                });
            }
        }
    };

    const title = { icon: "mdi mdi-clipboard-check-outline", label: translate('mapping:title', 'line-picking') };
    const subtitles = () => {
        let subtitlesItems = [];
        subtitlesItems = [...subtitlesItems, { label: update ? translate('menu.update', 'configuration') : translate('menu.insert', 'configuration') }]
        return subtitlesItems;
    }

    const onBlurPartNumber = (ev) => {
        if (!isNullOrEmpty(ev.currentTarget.value)) {
            mapping.partNumber = ev.currentTarget.value;
            ev.preventDefault();
            props.getPartNumberDescription(ev.currentTarget.value, (response) => {
                if (response && response.data) {
                    mapping.partNumberDesc = response.data.name;
                    setMapping({ ...mapping });
                }
            });

            props.getLastReceipt({ partNumberCode: ev.currentTarget.value }, (response) => {
                if (response) {
                    mapping.qme = response.qme;
                    mapping.mdr = response.mdr;
                    setMapping({ ...mapping });
                }
            });
        }
    }

    return (
        <div>
            <Breadcrumbs id="mappingInsert" title={title} subtitles={subtitles()} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <div className="card">
                        <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                            <form id="formMappingInsert" className="col s12">
                                <div className="row" style={{ padding: '10px' }}>
                                    <div className="input-field no-padding col s4 mb-6">
                                        <Input
                                            id="partNumberInput"
                                            name='partNumberInput'
                                            label={translate('mapping:partnumber', 'line-picking')}
                                            type="text"
                                            leadingzeros={11}
                                            numericonly="true"
                                            defaultValue={mapping?.partNumber || ''}
                                            onBlur={(ev) => { onBlurPartNumber(ev); }}
                                            required
                                        />
                                    </div>
                                    <div className="input-field no-padding col s7 mb-8">
                                        <Input
                                            id="partNumberDesc"
                                            name='partNumberDesc'
                                            label={translate('description', 'general')}
                                            type="text"
                                            disabled
                                            value={mapping?.partNumberDesc || ''}
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className='row' style={{ paddingLeft: '10px' }}>
                                        <div className="input-field no-padding col s6 mb-8">
                                            <SelectMapping
                                                required
                                                name='class'
                                                mappingType={ENUMS.eMappingRegistrationType.Class.value}
                                                defaultValue={mapping?.class || ''}
                                                onChange={onChange}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s5 mb-10">
                                            <SelectMapping
                                                required
                                                name='line'
                                                mappingType={ENUMS.eMappingRegistrationType.Line.value}
                                                defaultValue={mapping?.line || ''}
                                                onChange={onChange}
                                            />
                                        </div>
                                    </div>
                                    <div className='row' style={{ paddingLeft: '10px' }}>
                                        <div className="input-field no-padding">
                                            <SelectMappingModelUse
                                                required
                                                name='partNumberModelUse'
                                                mappingType="partNumberModelUse"
                                                setDefaultValues={(data) => {
                                                    if (data && data.length > 0 && !update) {
                                                        mapping.mappingPartNumberUseModelIds = data.map(f => f.id.toString());
                                                        setMapping({ ...mapping })
                                                    }
                                                }}
                                                partNumber={mapping?.partNumber}
                                                defaultValue={mapping?.mappingPartNumberUseModelIds}
                                                onChange={(array) => {
                                                    mapping.mappingPartNumberUseModelIds = array;
                                                    setMapping(mapping)
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="input-field no-padding col s5 m3">
                                        <SelectMapping
                                            showCode={true}
                                            required
                                            name='gravitational'
                                            mappingType={ENUMS.eMappingRegistrationType.Gravitational.value}
                                            defaultValue={mapping?.gravitational || ''}
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s6 m4">
                                        <SelectMapping
                                            required
                                            showCode={true}
                                            name='parts'
                                            mappingType={ENUMS.eMappingRegistrationType.Parts.value}
                                            defaultValue={mapping?.parts || ''}
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5 m4">
                                        <SelectItem
                                            {...props}
                                            id="side"
                                            defaultValue={mapping?.side || ''}
                                            label={translate('mapping:side', 'line-picking')}
                                            placeHolder={translate('general:choose-one-option')}
                                            minLength={0}
                                            onChange={onChange}
                                            onChangeData={onChange}
                                            changeEvent="true"
                                            data={[{ id: "SX", text: "SX", },
                                            { id: "DX", text: "DX" }
                                            ]}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s6 m3">
                                        <SelectItem
                                            {...props}
                                            id="route"
                                            defaultValue={mapping?.route || ''}
                                            label={translate('mapping:route', 'line-picking')}
                                            placeHolder={translate('general:choose-one-option')}
                                            minLength={0}
                                            onChange={onChange}
                                            onChangeData={onChange}
                                            changeEvent="true"
                                            data={arrayDrop} />
                                    </div>
                                    {/* <div className="input-field no-padding col s5 m4">
                                            <SelectMappingModelUse
                                                required
                                                name='use'
                                                mappingType="use"
                                                partNumber={mapping?.partNumber}
                                                defaultValue={mapping?.use || ''}
                                                onChange={onChange}
                                            />
                                        </div> */}


                                    <div className="input-field no-padding col s6 mb-8">
                                        <Input
                                            id="street"
                                            name='street'
                                            label={translate('mapping:street', 'line-picking')}
                                            type="text"
                                            maxLength="2"
                                            value={mapping?.street || ''}
                                            onChange={onChange}
                                            required
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5 mb-8">
                                        <Input
                                            id="station"
                                            name='station'
                                            label={translate('mapping:station', 'line-picking')}
                                            type="number"
                                            maxLength="3"
                                            value={mapping?.station || ''}
                                            onChange={onChange}
                                            required
                                        />
                                    </div>
                                    <div className="input-field no-padding col s4 mb-6">
                                        <Input
                                            id="space"
                                            name='space'
                                            label={translate('mapping:space', 'line-picking')}
                                            type="text"
                                            value={mapping?.space || ''}
                                            onChange={onChange}
                                            required
                                        />
                                    </div>
                                    <div className="input-field no-padding col s2 mb-6">
                                        <Input
                                            id="qme"
                                            name='qme'
                                            label={translate('mapping:qme', 'line-picking')}
                                            type="number"
                                            maxLength="6"
                                            value={mapping?.qme || ''}
                                            onChange={onChange}
                                            required
                                        />
                                    </div>
                                    <div className="input-field no-padding col s2 mb-6">
                                        <Input
                                            id="mdr"
                                            name='mdr'
                                            label={translate('mapping:mdr', 'line-picking')}
                                            type="text"
                                            value={mapping?.mdr || ''}
                                            onChange={onChange}
                                            required
                                        />
                                    </div>
                                    <div className="input-field no-padding col s2 mb-6">
                                        <Input
                                            id="boxLimit"
                                            name='boxLimit'
                                            label={translate('mapping:box-limit', 'line-picking')}
                                            type="number"
                                            maxLength="3"
                                            value={mapping?.boxLimit || ''}
                                            onChange={onChange}
                                            required
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5 mb-6">
                                        <Input
                                            id="picking"
                                            name='picking'
                                            label={translate('mapping:picking', 'line-picking')}
                                            type="text"
                                            numericonly={true}
                                            maxLength="4"
                                            value={mapping?.picking || ''}
                                            onChange={onChange}
                                            required
                                        />
                                    </div>
                                    <div className="input-field no-padding col s6 mb-8">
                                        <Input
                                            id="alternativePartNumber"
                                            name='alternativePartNumber'
                                            label={translate('mapping:alternative-partnumber', 'line-picking')}
                                            type="text"
                                            numericonly="true"
                                            value={mapping?.alternativePartNumber || ''}
                                            onChange={onChange}
                                        />
                                    </div>

                                    <div className="input-field no-padding col s5 mb-8">
                                        <Input
                                            id="pdu"
                                            name='pdu'
                                            label={translate('mapping:pdu', 'line-picking')}
                                            type="text"
                                            value={mapping?.pdu || ''}
                                            onChange={onChange}
                                            disabled
                                        />
                                    </div>
                                    <div className="input-field no-padding col s4  mb-6">
                                        <Input
                                            id="code"
                                            name='code'
                                            label={translate('mapping:code', 'line-picking')}
                                            type="text"
                                            leadingzeros={10}
                                            numericonly="true"
                                            value={mapping?.code || ''}
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div className="input-field no-padding  col s1">
                                    <button
                                        className="btn-floating btn-Small btn-principal waves-effect waves-light"
                                        type="button"
                                        onClick={() => setOpenModal(true)}>
                                        <i className="Small material-icons">cloud_upload</i>
                                    </button>
                                </div>
                            </form>
                            <div className="container" >
                                <Subtitle icon="mdi mdi-file-image-outline" label="Imagem Embalagem" />
                                <div className="card-panel hoverable">
                                    {
                                        (mapping.fileMdrNew || !isNullOrEmpty(mapping.fileNameMdr)) &&
                                        <div key={`key_mdr`} className="list sixth-text-color" style={{ paddingRight: '15px' }}>
                                            <img src={getNameFile(true)} style={{ width: '100px', height: '100px' }} alt={mapping.fileNameMdr} />
                                            <i onClick={() => console.log(mapping.fileMdrNew)} className={'mdi mdi-21px mdi-alpha-x-circle-outline'} />
                                        </div>
                                    }
                                    <Input
                                        id="fileMdr"
                                        name="fileMdr"
                                        type="file"
                                        accept="image/*"
                                        onChange={(event) => {
                                            addImage(event.target.files[0], true)
                                        }}
                                    />
                                </div>
                                <Subtitle icon="mdi mdi-file-image-outline" label="Imagem Desenho" />
                                <div className="card-panel hoverable">
                                    {
                                        (mapping.filePartNumberNew || !isNullOrEmpty(mapping.fileNamePartNumber)) &&
                                        <div key={`key_filePartNumber`} className="list sixth-text-color" style={{ paddingRight: '15px' }}>
                                            <img src={getNameFile(false)} style={{ width: '100px', height: '100px' }} alt={mapping.fileNamePartNumber} />
                                            <i onClick={() => console.log(mapping.filePartNumberNew)} className={'mdi mdi-21px mdi-alpha-x-circle-outline'} />
                                        </div>
                                    }
                                    <Input
                                        id="filePartNumber"
                                        name="filePartNumber"
                                        type="file"
                                        accept="image/*"
                                        onChange={(event) => {
                                            addImage(event.target.files[0], false)
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="row" style={{ paddingTop: '10px' }}>
                                <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                                <Button onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                            </div>
                        </div>
                    </div>
                </div>
            </div >
            <ModalUploadMapping
                open={openModal}
                id="ModalUploadMapping"
                onCancel={() => setOpenModal(false)}
                onClose={() => setOpenModal(false)}
                onConfirm={() => setOpenModal(false)}
                btnCancel={translate('cancel', 'general')}
                btnConfirm={translate('confirm', 'general')}
            />
        </div >
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        mapping: state.linePickingReducer.mapping
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        createMapping: (mapping, callback) => {
            dispatch(LinePickingService.createMapping(mapping, callback));
        },
        updateMapping: (mapping, callback) => {
            dispatch(LinePickingService.updateMapping(mapping, callback));
        },
        getPartNumberDescription: (code, callback) => {
            dispatch(LinePickingService.getPartNumberDescription(code, callback));
        },
        getLastReceipt: (filter, callback) => {
            dispatch(LinePickingService.getLastReceipt(filter, callback));
        },
        getLastMapping: (callback) => {
            dispatch(LinePickingService.getLastMapping(callback));
        },
        getRoutes: (filter, callback) => {
            dispatch(RoutePickingService.getRouteDrop(callback));
        },
        getVehiclesAll: (filter, callback) => {
            dispatch(StockService.getVehiclesAll(filter, callback));
        },
        getAreasAll: (filter, callback) => {
            dispatch(StockService.getAreasAll(filter, callback));
        },
        getMappingRegistrationAll: (filter, callback) => {
            dispatch(LinePickingService.getMappingRegistrationAll(filter, callback));
        },
        getPartnumbersUseModelAll: (filter, callback) => {
            dispatch(LinePickingService.getPartnumbersUseModelAll(filter, callback));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(MappingInsert));